<!--
  功能：预览页的因子池组合 (带交并集)
  作者：wangwenhao
  邮箱：wangwenhao@gw.com.cn
  时间：
  版本：v1.0
  修改记录：
  修改内容：
  修改人员：
  修改时间：
-->
<template>
    <div>
        <!-- 标题 -->
        <div class="factor-arguments-title" @click="setContentH()">
            <div class="title-text" >
                 <img src="@/assets/image/factor/factor-text.png" alt="" srcset="" class="title-text-img" >
            </div>
            <div class="title-suffix">
                <img
                    src="@/assets/image/factor/arrow-down.png"
                    alt=""
                    srcset=""
                    v-if="!showAllContent"
                />
                <img src="@/assets/image/factor/arrow-up.png" alt="" srcset="" v-else />
            </div>
        </div>
        <!-- 交并集因子内容 -->
        <div class="actionSheet-content-hidden" @click="setContentH()" >
            <div class="actionSheet-content" :class="{ 'show-all-content': showAllContent }">
                <!-- 最外层 交/并因子 -->
                <div
                    class="actionSheet-factor-info"
                    :class="
                        collection_condition.yzList.length > 1 ||
                        collection_condition.children.length > 0
                            ? 'multi-factor'
                            : ''
                    "
                >
                    <van-row>
                        <van-col
                            span="24"
                            class="actionSheet-factor-item-col col-outer-layer"
                            :class="{
                                'last-outer-layer':
                                    indexP === collection_condition.yzList.length - 1
                            }"
                            v-for="(factorP, indexP) in collection_condition.yzList"
                            :key="indexP"
                        >
                            <!-- 常规因子 -->
                            <div class="actionSheet-factor-item" v-if="factorP.yzType == 0">
                                <div class="actionSheet-factor-item-text">
                                    <div class="actionSheet-factor-item-name">
                                        {{ factorP.FactorName }}
                                    </div>
                                    <div class="actionSheet-factor-item-desc">
                                        {{ factorP.SubClassName }}
                                    </div>
                                </div>
                                <div class="actionSheet-factor-item-num">
                                    <div
                                        class="actionSheet-factor-item-zf"
                                        :class="[judgeColor(factorP.RiZhangFu)]"
                                    >
                                        {{ toFixedNum(factorP.RiZhangFu * 100, 2, '%', true) }}
                                    </div>
                                    <div class="actionSheet-factor-item-zhi">
                                        {{ factorP.XinHaoShuLiang }}只
                                    </div>
                                    <!-- 非按钮 -->
                                    <div class="actionSheet-factor-non">
                                        <img
                                            src="@/assets/image/factor/non-l.png"
                                            alt=""
                                            srcset=""
                                            v-if="factorP.isNon"
                                        />
                                        <!-- <img
                                            src="@/assets/image/factor/non-n.png"
                                            alt=""
                                            srcset=""
                                            v-else
                                        /> -->
                                    </div>
                                </div>
                            </div>
                            <!-- 非常规 -->
                            <div class="actionSheet-factor-item" v-else>
                                <div class="actionSheet-factor-item-text others-left">
                                    <div class="actionSheet-factor-item-name">
                                        {{ factorP.FactorName }}
                                    </div>
                                    <div class="actionSheet-factor-item-desc">
                                        {{ factorP.SubClassName }}
                                    </div>
                                </div>
                            </div>
                        </van-col>
                        <!-- 组合内的因子(内层) -->
                        <div
                            v-if="collection_condition.children.length > 0"
                            v-for="(valueSwitch, indexSwitch) in collection_condition.children"
                            :index="indexSwitch"
                        >
                            <van-col span="24" class="actionSheet-factor-item-col group-info">
                                <div class="actionSheet-group-info">
                                    <van-row>
                                        <!-- 有数据时 -->
                                        <template
                                            v-if="
                                                valueSwitch.length > 0 &&
                                                collection_condition.children[indexSwitch] &&
                                                collection_condition.children[indexSwitch].length >
                                                    0
                                            "
                                        >
                                            <van-col
                                                span="24"
                                                class="actionSheet-group-item-col draggable-item"
                                                v-for="(factorS, indexS) in valueSwitch"
                                                :key="indexS"
                                                v-if="
                                                    collection_condition.children[indexSwitch]
                                                        .length > 0
                                                "
                                            >
                                                <!-- 常规因子 -->
                                                <div
                                                    class="actionSheet-group-item"
                                                    v-if="factorS.yzType == 0"
                                                >
                                                    <div class="actionSheet-group-item-text">
                                                        <div class="actionSheet-group-item-name">
                                                            {{ factorS.FactorName }}
                                                        </div>
                                                        <div class="actionSheet-group-item-desc">
                                                            {{ factorS.SubClassName }}
                                                        </div>
                                                    </div>
                                                    <div class="actionSheet-group-item-num">
                                                        <div
                                                            class="actionSheet-group-item-zf"
                                                            :class="[judgeColor(factorS.RiZhangFu)]"
                                                        >
                                                            {{
                                                                toFixedNum(
                                                                    factorS.RiZhangFu * 100,
                                                                    2,
                                                                    '%',
                                                                    true
                                                                )
                                                            }}
                                                        </div>
                                                        <div class="actionSheet-group-item-zhi">
                                                            {{ factorS.XinHaoShuLiang }}只
                                                        </div>
                                                        <!-- 非按钮 -->
                                                        <div class="actionSheet-factor-non">
                                                            <img
                                                                src="@/assets/image/factor/non-l.png"
                                                                alt=""
                                                                srcset=""
                                                                v-if="factorS.isNon"
                                                            />
                                                            <!-- <img
                                                                src="@/assets/image/factor/non-n.png"
                                                                alt=""
                                                                srcset=""
                                                                v-else
                                                            /> -->
                                                        </div>
                                                    </div>
                                                </div>
                                                <!-- 非常规 -->
                                                <div class="actionSheet-group-item" v-else>
                                                    <div
                                                        class="actionSheet-group-item-text others-left"
                                                    >
                                                        <div class="actionSheet-group-item-name">
                                                            {{ factorS.FactorName }}
                                                        </div>
                                                        <div class="actionSheet-group-item-desc">
                                                            {{ factorS.SubClassName }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </van-col>
                                        </template>
                                    </van-row>
                                    <!-- 且&或文字的展示 -->
                                    <div class="actionSheet-group-qh-text">
                                        {{
                                            collection_condition.composeType === 'jj' ? '或' : '且'
                                        }}
                                    </div>
                                </div>
                            </van-col>
                        </div>
                    </van-row>
                    <!-- 且&或文字的展示 -->
                    <div
                        class="actionSheet-factor-qh-text"
                        v-if="
                            collection_condition.yzList.length > 1 ||
                            collection_condition.children.length > 0
                        "
                    >
                        {{ collection_condition.composeType === 'jj' ? '且' : '或' }}
                    </div>
                </div>
                <!-- 收起的遮罩 -->
                <div class="actionSheet-content-hidden-mask" v-if="!showAllContent"></div>
            </div>
        </div>
    </div>
</template>

<script>
import { toFixedNum, judgeColor } from '@/utils/format';
export default {
    name: 'FactorDetailModal',
    // 简单数组形式
    props: ['collection_condition'],
    data() {
        return {
            // 是否显示全部内容
            showAllContent: false
        };
    },
    filters: {},
    // 侦听器
    watch: {},
    computed: {},
    /**
     * 组件实例创建完成，属性已绑定，但DOM还未生成，$ el属性还不存在
     */
    created() {},
    /**
     * el 被新创建的 vm.$ el 替换，并挂载到实例上去之后调用该钩子。
     * 如果 root 实例挂载了一个文档内元素，当 mounted 被调用时 vm.$ el 也在文档内。
     */
    mounted: function () {
        console.log('collection_condition', this.collection_condition);
    },
    // 组件方法
    methods: {
        judgeColor,
        toFixedNum,
        setContentH: function () {
            this.showAllContent = !this.showAllContent;
        }
    }
};
</script>

<style scoped lang="less">
.factor-arguments-title {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: flex-start;
    align-items: center;
    font-weight: 700;
    font-size: 14px;
    margin-bottom: 8px;
    background: linear-gradient(270deg, #286df7 0%, #158fff 90.48%),
        linear-gradient(270deg, #286df7 0%, #158fff 90.48%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-fill-color: transparent;
    .title-text {
        height: 14px;
        width: 85px;
        .title-text-img {
            display: block;
            width: 100%;
            height: 100%;
        }
    }
    .title-prefix {
        margin-right: 5px;
    }
    .title-suffix {
        width: 16px;
        height: 16px;
        .title-suffix-icon {
            display: block;
            width: 100%;
            height: 100%;
        }
    }
}
// 交并集因子内容
.show-all-content {
    max-height: 2000px !important;
}
.actionSheet-content {
    border-radius: 8px;
    padding: 10px;
    background: rgba(255, 255, 255, 0.3);
    max-height: 110px;
    // transition: max-height 0.5s ease-in-out;
    overflow: hidden;
    position: relative;
    // 多个因子展示弧线
    .multi-factor {
        padding-left: 17px;
        border-left: 1px solid rgba(59, 133, 254, 1);
        border-radius: 10px;
    }
    .actionSheet-factor-info {
        position: relative;
        .actionSheet-factor-item-col {
            position: relative;
        }
        .actionSheet-factor-item {
            background: #ffffff;
            border-radius: 6px;
            margin-bottom: 10px;
            padding: 6px 10px;
            display: flex;
            .others-left {
                width: 90% !important;
            }
            .others-rigth {
                width: 10% !important;
                background: rgba(0, 0, 0, 0) !important;
            }
            .actionSheet-factor-item-text {
                width: 45%;
                .actionSheet-factor-item-name {
                    color: #222222;
                    font-size: 14px;
                    font-weight: 500;
                    // 溢出隐藏显示...
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
                .actionSheet-factor-item-desc {
                    color: #999999;
                    font-size: 10px;
                    // 溢出隐藏显示...
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
            }
            .actionSheet-factor-item-num {
                width: 55%;
                display: flex;
                flex-direction: row;
                flex-wrap: nowrap;
                align-content: center;
                justify-content: flex-start;
                align-items: center;
                background: rgba(0, 0, 0, 0.02);
                border-radius: 4px;
                .actionSheet-factor-item-zf {
                    font-size: 12px;
                    font-weight: 600;
                    margin-left: 12px;
                    margin-right: 8px;
                }
                .actionSheet-factor-item-zhi {
                    color: #555555;
                    font-size: 12px;
                }
                // 非按钮
                .actionSheet-factor-non {
                    margin-left: auto;
                    width: 16px;
                    height: 16px;
                    img {
                        width: 100%;
                        height: 100%;
                        display: block;
                    }
                }
                // 删除按钮
                .actionSheet-factor-del {
                    margin-left: 18px;
                    width: 16px;
                    height: 16px;
                    img {
                        width: 100%;
                        height: 100%;
                        display: block;
                    }
                }
            }
        }

        /* 让最后一条因子没有 margin-bottom */
        .col-outer-layer.last-outer-layer .actionSheet-factor-item {
            margin-bottom: 0;
        }

        // 且跟或的文字按钮 靠左居中
        .actionSheet-factor-qh-text {
            position: absolute;
            left: -9px;
            top: 50%;
            transform: translateY(-50%);
            background: #e5ecfa;
            border-radius: 4px;
            padding: 4px 2px;
            color: #286df7;
            font-size: 14px;
        }

        // 分组中的样式
        .group-info {
            margin-top: 10px;
            position: relative;
        }
        .group-del {
            position: absolute;
            top: -8px;
            right: -8px;
            width: 16px;
            height: 16px;
            img {
                width: 100%;
                height: 100%;
                display: block;
            }
        }
        .actionSheet-group-info {
            position: relative;
            padding-left: 15px;
            border-left: 1px solid #3b85fe;
            border-radius: 10px;
            // 空数据
            .group-empty-col {
                .group-empty-col-text {
                    text-align: center;
                    color: #949da8;
                    font-size: 12px;
                    margin-bottom: 5px;
                }
                .group-empty-col-box {
                    height: 28px;
                    border: 1px dashed #D9D9D9;
                    border-radius: 4px;
                    // padding: 4px 6px;
                    display: flex;
                    margin-bottom: 8px;
                    .group-empty-col-box-left {
                        width: 50%;
                        border-right: 1px dashed #e7e9f0;
                        display: flex;
                        flex-direction: row;
                        flex-wrap: nowrap;
                        align-content: center;
                        justify-content: space-around;
                        align-items: center;
                        padding: 6px;
                        .group-empty-col-box-item {
                            background: #ECECF0;
                            border-radius: 2px;
                            height: 20px;
                            display: inline-block;
                            width: 24%;
                        }
                    }
                    .group-empty-col-box-right {
                        width: 50%;

                        display: flex;
                        flex-direction: row;
                        flex-wrap: nowrap;
                        align-content: center;
                        justify-content: space-around;
                        align-items: center;
                        padding: 6px;
                        .group-empty-col-box-item {
                            background: #ECECF0;
                            border-radius: 2px;
                            height: 20px;
                            display: inline-block;
                            width: 49%;
                        }
                    }
                }
            }
        }
        .actionSheet-factor-add-text {
            border: 1px dashed #d9d9d9;
            height: 36px;
            line-height: 36px;
            border-radius: 4px;
            text-align: center;
            color: #949da8;
            font-size: 12px;
        }
        .actionSheet-group-item-col {
            position: relative;
            .actionSheet-group-item {
                background: #ffffff;
                border-radius: 6px;
                margin-bottom: 10px;
                padding: 6px 10px;
                display: flex;
                padding-right: 6px;
                .others-left {
                    width: 90% !important;
                }
                .others-rigth {
                    width: 10% !important;
                    background: rgba(0, 0, 0, 0) !important;
                }
                .actionSheet-group-item-text {
                    width: 45%;
                    .actionSheet-group-item-name {
                        color: #222222;
                        font-size: 14px;
                        font-weight: 500;
                        // 溢出隐藏显示...
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                    .actionSheet-group-item-desc {
                        color: #999999;
                        font-size: 10px;
                        // 溢出隐藏显示...
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                }
                .actionSheet-group-item-num {
                    width: 55%;
                    display: flex;
                    flex-direction: row;
                    flex-wrap: nowrap;
                    align-content: center;
                    justify-content: flex-start;
                    align-items: center;
                    background: rgba(0, 0, 0, 0.02);
                    border-radius: 4px;
                    .actionSheet-group-item-zf {
                        font-size: 12px;
                        font-weight: 600;
                        margin-left: 12px;
                        margin-right: 8px;
                    }
                    .actionSheet-group-item-zhi {
                        color: #555555;
                        font-size: 12px;
                    }
                    // 非按钮
                    .actionSheet-factor-non {
                        margin-left: auto;
                        width: 16px;
                        height: 16px;
                        img {
                            width: 100%;
                            height: 100%;
                            display: block;
                        }
                    }
                    // 删除按钮
                    .actionSheet-factor-del {
                        margin-left: 18px;
                        width: 16px;
                        height: 16px;
                        img {
                            width: 100%;
                            height: 100%;
                            display: block;
                        }
                    }
                }
            }
        }
        /* 让最后一条因子没有 margin-bottom */
        .actionSheet-group-info .actionSheet-group-item-col:last-child .actionSheet-group-item {
            margin-bottom: 0;
        }
        // 且跟或的文字按钮 靠左居中
        .actionSheet-group-qh-text {
            position: absolute;
            left: -9px;
            top: 50%;
            transform: translateY(-50%);
            background: #e5ecfa;
            border-radius: 4px;
            padding: 4px 2px;
            color: #286df7;
            font-size: 14px;
        }
    }
    .actionSheet-content-hidden-mask {
        height: 38px;
        position: absolute;
        bottom: 0px;
        left: 0px;
        width: 100%;
        background: linear-gradient(to bottom, rgba(221, 231, 254, 0) 0.05%, #dde7fe 102.3%);
        border-radius: 0px 0px 8px 8px;
    }
}

// 黑版样式
.black_theme {
    // 交并集的tab
    .actionSheet-tab {
        .actionSheet-tab-bg {
            background-color: #20232e;
            .actionSheet-tab-item {
                color: #aab9d1;
            }
            .active {
                background: #3b85fe;
                color: #e4e9fe;
            }
        }
    }
    // 交并集内容
    .actionSheet-content {
        background: #1f222e;
        .actionSheet-factor-info {
            border-left: 1px solid rgba(59, 133, 254, 1);

            .actionSheet-factor-item {
                background: #272935;
                .actionSheet-factor-item-text {
                    .actionSheet-factor-item-name {
                        color: #e4e9fe;
                    }
                    .actionSheet-factor-item-desc {
                        color: #999999;
                    }
                }
                .actionSheet-factor-item-num {
                    background: rgba(255, 255, 255, 0.02);
                    .actionSheet-factor-item-zhi {
                        color: #aab9d1;
                    }
                }
            }

            // 且跟或的文字按钮 靠左居中
            .actionSheet-factor-qh-text {
                background: #314770;
                color: #3b85fe;
            }

            // 分组中的样式
            .group-info {
                border: 1px solid #353843;
            }
            .actionSheet-group-info {
                border-left: 1px solid #3b85fe;
                // 空数据
                .group-empty-col {
                    .group-empty-col-text {
                        color: #697689;
                    }
                    .group-empty-col-box {
                        border: 1px dashed rgba(255, 255, 255, 0.1);
                        .group-empty-col-box-left {
                            border-right: 1px dashed #3c404c;
                            .group-empty-col-box-item {
                                background: rgba(255, 255, 255, 0.03);
                            }
                        }
                        .group-empty-col-box-right {
                            .group-empty-col-box-item {
                                background: rgba(255, 255, 255, 0.03);
                            }
                        }
                    }
                }
            }
            .actionSheet-factor-add-text {
                border: 1px dashed #353843;
                color: #697689;
            }
            .actionSheet-group-item-col {
                .actionSheet-group-item {
                    background: #272935;
                    .actionSheet-group-item-text {
                        .actionSheet-group-item-name {
                            color: #e4e9fe;
                        }
                        .actionSheet-group-item-desc {
                            color: #999999;
                        }
                    }
                    .actionSheet-group-item-num {
                        background: rgba(255, 255, 255, 0.02);

                        .actionSheet-group-item-zhi {
                            color: #aab9d1;
                        }
                    }
                }
            }

            // 且跟或的文字按钮 靠左居中
            .actionSheet-group-qh-text {
                background: #314770;
                color: #3b85fe;
            }
        }
        // 添加组合按钮
        .group-add-btn {
            background: rgba(59, 133, 254, 0.1);
            color: #5495ff;
        }
    }
    .actionSheet-content-hidden-mask {
        background: linear-gradient(102.86deg, rgba(12, 15, 19, 0) 0.05%, #0c0f13 89.71%);
    }
}
</style>
